// src/components/Seo.tsx
import { Helmet } from "react-helmet-async";

const SiteTitel = "탄소중립 및 ESG컨설팅｜(주)아키테코그룹 - ArchitecoGroup";
const SiteUrl = "https://architeco-geo.com";
const DefultDescripion = "스마트 그린 및 ESG 플랫폼 리더, (주)아키테코그룹 공식 홈페이지입니다. 넷제로 기반의 기후테크 전문성을 바탕으로 2050 탄소중립을 위한 최적의 컨설팅, R&D, 친환경 디자인 및 IT 솔루션을 제공합니다.";
const DefultKeyword = "아키테코그룹, ESG, 친환경, 친환경컨설팅, ESG플랫폼";
const DefultImg = `${SiteUrl}/imgs/ci.png`;
const DefultAuthor = "Architeco-geo";

type SeoProps = {
  title?: string;
  description?: string;
  keywords?: string;
  path?: string;
  image?: string;
};

export function Seo({ title, description, keywords, path, image }: SeoProps) {
  const fullTitle = title ? `${title}` : SiteTitel;
  const url = `${SiteUrl}${path}`;
  const metaDescription = description ?? DefultDescripion;
  const metaKeywords = keywords ?? DefultKeyword;
  const metaImage = image ?? DefultImg;

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={DefultAuthor} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content={SiteTitel} />
    </Helmet>
  );
}
